/** Stable codex_users.id values that must never appear in PostHog (founders, QA, bots). */

let cachedExcludedIds: Set<string> | null = null;

function parseCsvIds(raw: string | undefined): string[] {
  if (!raw?.trim()) return [];
  return raw
    .split(",")
    .map((id) => id.trim().toLowerCase())
    .filter(Boolean);
}

/**
 * Client allowlist — populated from NEXT_PUBLIC_POSTHOG_EXCLUDED_USER_IDS at build time
 * (next.config merges POSTHOG_EXCLUDED_USER_IDS + FOUNDER_USER_IDS).
 */
export function getPostHogExcludedUserIds(): ReadonlySet<string> {
  if (cachedExcludedIds) return cachedExcludedIds;

  const ids = parseCsvIds(process.env.NEXT_PUBLIC_POSTHOG_EXCLUDED_USER_IDS);
  cachedExcludedIds = new Set(ids);
  return cachedExcludedIds;
}

export function isPostHogExcludedUserId(userId: string | null | undefined): boolean {
  if (!userId?.trim()) return false;
  return getPostHogExcludedUserIds().has(userId.trim().toLowerCase());
}
